import { optionalOneOf, optionalString, optionalSearch } from "@/lib/search";
import type { SmsListView } from "./sms-inbox";

const SORTS = ["oldest", "name", "unread", "starred"] as const;
const FILTERS = ["needs-reply", "unread"] as const;

/** What the inbox's search, community, order and filter keep in the address. */
export interface SmsListSearch {
  q?: string;
  community?: string;
  sort?: (typeof SORTS)[number];
  filter?: (typeof FILTERS)[number];
}

export function smsListSearch(search: Record<string, unknown>): SmsListSearch {
  return {
    q: optionalSearch(search.q),
    community: optionalString(search.community)?.slice(0, 60) || undefined,
    sort: optionalOneOf(SORTS, search.sort),
    filter: optionalOneOf(FILTERS, search.filter),
  };
}

/** The list view the inbox reads, with each choice written back through `patch`. */
export function smsListView(
  search: SmsListSearch,
  term: string,
  setTerm: (next: string) => void,
  patch: (next: SmsListSearch) => void,
): SmsListView {
  return {
    value: {
      term,
      community: search.community ?? "all",
      sort: search.sort ?? "recent",
      filter: search.filter ?? "all",
    },
    setTerm,
    setCommunity: (next) => patch({ community: next === "all" ? undefined : next }),
    setSort: (next) => patch({ sort: optionalOneOf(SORTS, next) }),
    setFilter: (next) => patch({ filter: optionalOneOf(FILTERS, next) }),
  };
}
